module.exports = __webpack_public_path__ + "img/pairui.1f2086a1.jpg";